import { success, invalid, failure, request } from "./helpers";
import {
  STATS_BY_DEVICE_TYPE,
  STATS_BY_DEVICE_MODEL,
  STATS_BY_OS_TYPE,
  STATS_BY_TIME,
  STATS_BY_POPULAR_PAGE,
  STATS_BY_REGIONAL_TRAFFIC,
  STATS_BY_TIME_OF_DAY,
  STATS_BY_DEMOGRAPHIC,
  STATS_BY_PRIMARY_DEVICES,
  STATS_TOP_ATTRIBUTES,
  CLEAR_ALL_STATS,
  SET_REPORT_DAY_RANGE,
  SET_REPORT_WEBSITE_ID,
  GET_HEAT_MAP_DATA,
  GET_AUDIENCE_FILES_DATA,
  CLEAR_AUDIENCE_FILES_DATA,
  GET_TAG_AUDIENCE_FILES,
  DOWNLOAD_AUDIENCE_FILES,
  SEND_ASSIST_REQUEST,
  OVERVIEW_TRAFFIC_REPORT,
  DOMESTIC_CONSUMER_VISITS_REPORT,
  DOMESTIC_BUSINESS_STATS,
  CLEAR_ALL_DOMESTIC_STATS,
  GET_DOMESTIC_VISITS,
  GET_TOP_20_FREQUENCY_BUSINESSES,
  GET_SEGMENT_DISTRIBUTION,
  GET_TOP_5_OS_BREAKDOWN_REPORT,
  GET_SEGMENT_DISTRIBUTION_DETAIL_REPORT,
  GET_SEGMENT_DISTRIBUTION_DEVICE_MODEL_REPORT,
  GET_SEGMENT_DISTRIBUTION_DEVICE_TYPE_REPORT,
  GET_INSIGHTS_POPULAR_PAGES,
  SET_PAGE_FAVORITE,
  GET_FAVORITE_PAGES,
  GET_BY_STATES,
  GET_SEGMENT_DISTRIBUTION_SYSTEMS,
  GET_CULTURE_CODE_REPORT,
  GET_HEATMAP_DATA,
  SET_REPORT_GRANULARITY,
} from "../actions/Insights";

import {
  TAG_WEBSITE_NAME,
  TAG_WEBSITE_URL,
  TAG_CAMPAIGN_NAME,
  SAVE_TAG,
  GENERATE_TAG,
  UPDATE_TAG,
  CLEAR_INSIGHT_TAG_INFO,
  CLEAR_TAG_ERROR,
  GET_TAG_DETAIL,
} from "../actions/tags";
import {
  CREATE_AUDIENCE_AT_SCALE,
  CREATE_AUDIENCE_AT_VISITORS,
  CLEAR_CREATE_VISITORS_AUDIENCE_INFO,
  CLEAR_CREATE_SCALE_AUDIENCE_INFO,
} from "../actions/SegmentCreation";
const localWebsiteId = window.localStorage.getItem("__websiteId__");
const initialState = {
  tag_variables: [],
  dayRange: window.localStorage.getItem("dayRange"),
  granularity: window.localStorage.getItem("granularity"),
  websiteId: localWebsiteId !== undefined ? +localWebsiteId : undefined,
};

const mockTopAttrStr =
  '{"demographic":[{"id":203,"name":"Dwelling Type","valueId":2030001,"value":"S","label":"Single Family","visitors":121,"visitorPercentage":0.8402778},{"id":113,"name":"Preferred Channel","valueId":1130011,"value":"K","label":"Brick/Mortar","visitors":109,"visitorPercentage":0.13374233},{"id":108,"name":"Ethnicity","valueId":1080011,"value":"K","label":"Western European","visitors":105,"visitorPercentage":0.7},{"id":113,"name":"Preferred Channel","valueId":1130001,"value":"A","label":"Broadcast/Cable TV","visitors":99,"visitorPercentage":0.121472396},{"id":201,"name":"Home Owner","valueId":2010001,"value":"Y","label":"Yes","visitors":98,"visitorPercentage":0.80991733},{"id":113,"name":"Preferred Channel","valueId":1130004,"value":"D","label":"Internet Radio","visitors":93,"visitorPercentage":0.11411043},{"id":113,"name":"Preferred Channel","valueId":1130010,"value":"J","label":"Satellite Radio","visitors":91,"visitorPercentage":0.11165644},{"id":113,"name":"Preferred Channel","valueId":1130008,"value":"H","label":"Online Streaming TV","visitors":89,"visitorPercentage":0.10920245},{"id":112,"name":"Membership","valueId":1120002,"value":"B","label":"Union Member","visitors":88,"visitorPercentage":0.6875},{"id":113,"name":"Preferred Channel","valueId":1130013,"value":"M","label":"E-tailer","visitors":87,"visitorPercentage":0.10674847}],"behavioral":[{"id":460,"name":"Travel","valueId":4600004,"value":"D","label":"Frequent Cruise","visitors":91,"visitorPercentage":0.18019801},{"id":460,"name":"Travel","valueId":4600001,"value":"A","label":"Frequent Domestic Vacation","visitors":91,"visitorPercentage":0.18019801},{"id":402,"name":"Online Buyer","valueId":4020023,"value":"W","label":"Tools/Automotive","visitors":90,"visitorPercentage":0.06451613},{"id":460,"name":"Travel","valueId":4600005,"value":"E","label":"Frequent Flyer","visitors":87,"visitorPercentage":0.17227723},{"id":460,"name":"Travel","valueId":4600006,"value":"F","label":"Hotel Program Members","visitors":87,"visitorPercentage":0.17227723},{"id":460,"name":"Travel","valueId":4600003,"value":"C","label":"Frequent Business Travel","visitors":87,"visitorPercentage":0.17227723},{"id":407,"name":"Movies","valueId":4070001,"value":"A","label":"Attended in Last 6 months","visitors":85,"visitorPercentage":0.4314721},{"id":422,"name":"Restaurant Style","valueId":4220001,"value":"A","label":"Eats Family Style","visitors":84,"visitorPercentage":0.54901963},{"id":423,"name":"Reading","valueId":4230001,"value":"A","label":"Book Reader","visitors":83,"visitorPercentage":0.38967136},{"id":402,"name":"Online Buyer","valueId":4020005,"value":"E","label":"Food and Beverage","visitors":82,"visitorPercentage":0.058781363}]}';
const mockHeatMapStr =
  '[{"lon":-95.9374,"lat":41.2596,"u":8},{"lon":-71.4133,"lat":41.8238,"u":1},{"lon":-95.9374,"lat":41.2596,"u":1},{"lon":-87.9067,"lat":43.0386,"u":1},{"lon":-84.3884,"lat":33.7486,"u":3},{"lon":-84.4567,"lat":39.5538,"u":1},{"lon":-84.7632,"lat":42.7448,"u":1},{"lon":-86.4201,"lat":37.1031,"u":1},{"lon":-117.6848,"lat":33.649,"u":1},{"lon":-95.9374,"lat":41.2596,"u":1},{"lon":-95.9374,"lat":41.2596,"u":1},{"lon":-97.1183,"lat":32.6288,"u":1},{"lon":-122.773,"lat":38.2181,"u":1}]';
const top20Buisiness = "[]";
//'[{"companyId":367197654,"companyName":"Mo******","industry":"Professional, Scientific, and Technical Services","revenue":66744000,"employees":150,"age":26},{"companyId":393134143,"companyName":"Go******","industry":"Information","revenue":827000,"employees":3,"age":null},{"companyId":545492985,"companyName":"So******","industry":"Construction","revenue":46457000,"employees":200,"age":null},{"companyId":427222250,"companyName":"Sn******","industry":"Professional, Scientific, and Technical Services","revenue":509000,"employees":2,"age":null},{"companyId":711379982,"companyName":"Ac******","industry":"Information","revenue":null,"employees":1500,"age":49},{"companyId":725787613,"companyName":"Lu******","industry":"Finance and Insurance","revenue":598000,"employees":2,"age":38}]';
export const insights = (state = initialState, action) => {
  switch (action.type) {
    case request(STATS_BY_DEVICE_TYPE):
      return {
        ...state,
        loadingStatsByDeviceType: true,
      };
    case success(STATS_BY_DEVICE_TYPE):
      return {
        ...state,
        statsByDevice: action.payload,
        loadingStatsByDeviceType: false,
      };
    case request(STATS_BY_DEVICE_MODEL):
      return {
        ...state,
        loadingStatsByDeviceModel: true,
      };
    case success(STATS_BY_DEVICE_MODEL):
      return {
        ...state,
        statsByDeviceModel: action.payload,
        loadingStatsByDeviceModel: false,
      };
    case request(STATS_BY_OS_TYPE):
      return {
        ...state,
        loadingStatsByOsType: true,
      };
    case success(STATS_BY_OS_TYPE):
      return {
        ...state,
        statsByOsType: action.payload,
        loadingStatsByOsType: false,
      };
    case request(STATS_BY_TIME):
      return {
        ...state,
        loadingStatsByTime: true,
      };
    case success(STATS_BY_TIME):
      return {
        ...state,
        statsByTime: action.payload,
        loadingStatsByTime: false,
      };
    case request(STATS_BY_POPULAR_PAGE):
      return {
        ...state,
        loadingStatsByPopularPage: true,
      };
    case success(STATS_BY_POPULAR_PAGE):
      return {
        ...state,
        statsByPopularPages: action.payload,
        loadingStatsByPopularPage: false,
      };
    case request(STATS_BY_REGIONAL_TRAFFIC):
      return {
        ...state,
        loadingStatsByRegionalTraffic: true,
      };
    case success(STATS_BY_REGIONAL_TRAFFIC):
      return {
        ...state,
        statsByRegionalTraffic: action.payload,
        loadingStatsByRegionalTraffic: false,
      };
    case request(STATS_BY_TIME_OF_DAY):
      return {
        ...state,
        loadingStatsByTimeOfDay: true,
      };
    case success(STATS_BY_TIME_OF_DAY):
      return {
        ...state,
        statsByTimeOfDay: action.payload,
        loadingStatsByTimeOfDay: false,
      };
    case request(STATS_BY_DEMOGRAPHIC):
      return {
        ...state,
        loadingStatsByDemographic: true,
      };
    case success(STATS_BY_DEMOGRAPHIC):
      return {
        ...state,
        statsByDemographic: action.payload,
        loadingStatsByDemographic: false,
      };
    case request(STATS_BY_PRIMARY_DEVICES):
      return {
        ...state,
        loadingStatsByPrimaryDevices: true,
      };
    case success(STATS_BY_PRIMARY_DEVICES):
      return {
        ...state,
        statsByPrimaryDevices: action.payload,
        loadingStatsByPrimaryDevices: false,
      };
    case request(STATS_TOP_ATTRIBUTES):
      return {
        ...state,
        loadingStatsTopAttributes: true,
      };
    case success(STATS_TOP_ATTRIBUTES):
      return {
        ...state,
        statsTopAttributes: action.payload,
        loadingStatsTopAttributes: false,
      };
    case invalid(STATS_TOP_ATTRIBUTES):
    case failure(STATS_TOP_ATTRIBUTES):
      return {
        ...state,
        statsTopAttributes: JSON.parse(mockTopAttrStr),
        loadingStatsTopAttributes: false,
      };
    case CLEAR_ALL_STATS:
      return {
        ...state,
        statsByDemographic: undefined,
        statsByDevice: undefined,
        statsByPopularPages: undefined,
        statsByRegionalTraffic: undefined,
        statsByTime: undefined,
        statsByTimeOfDay: undefined,
        statsTopAttributes: undefined,
        statsByPrimaryDevices: undefined,
        heatMapPoints: undefined,
      };
    case SET_REPORT_DAY_RANGE:
      window.localStorage.setItem("dayRange", action.value);
      return {
        ...state,
        dayRange: action.value,
      };
    case SET_REPORT_GRANULARITY:
      window.localStorage.setItem("granularity", action.value);
      return {
        ...state,
        granularity: action.value,
      };
    case SET_REPORT_WEBSITE_ID:
      window.localStorage.setItem("__websiteId__", action.value);
      return {
        ...state,
        websiteId: action.value,
      };
    case request(GET_HEAT_MAP_DATA):
      return {
        ...state,
        loadingStatsByRegionalTraffic: true,
      };
    case success(GET_HEAT_MAP_DATA):
      return {
        ...state,
        heatMapPoints: action.payload,
        loadingStatsByRegionalTraffic: false,
      };
    case invalid(GET_HEAT_MAP_DATA):
    case failure(GET_HEAT_MAP_DATA):
      return {
        ...state,
        loadingStatsByRegionalTraffic: false,
        heatMapPoints: JSON.parse(mockHeatMapStr),
      };
    case TAG_WEBSITE_NAME:
      return {
        ...state,
        website_name: action.value,
      };
    case TAG_WEBSITE_URL:
      return {
        ...state,
        website_url: action.value,
      };
    case TAG_CAMPAIGN_NAME:
      return {
        ...state,
        campaign_name: action.value,
      };
    case success(GENERATE_TAG):
      return {
        ...state,
        tag_info: action.payload,
        tag_error_message: undefined,
        tag_variables: [],
      };
    case success(UPDATE_TAG):
      return {
        ...state,
        tag_info: action.payload,
        tag_error_message: undefined,
        tag_variables: [],
        tag_updated_success: true,
      };
    case request(UPDATE_TAG):
      return {
        ...state,
        tag_updated_success: undefined,
      };
    case invalid(GENERATE_TAG):
    case failure(GENERATE_TAG):
      return {
        ...state,
        tag_info: undefined,
        tag_error_message: action.payload.message,
      };
    case invalid(UPDATE_TAG):
    case failure(UPDATE_TAG):
      return {
        ...state,
        tag_info: undefined,
        tag_error_message: action.payload.message,
        tag_updated_success: undefined,
      };
    case success(SAVE_TAG):
      return {
        ...state,
        tag_info: undefined,
        website_name: undefined,
        website_url: undefined,
        tag_error_message: undefined,
      };
    case invalid(SAVE_TAG):
    case failure(SAVE_TAG):
      return {
        ...state,
        tag_error_message: action.payload.message,
      };

    case CLEAR_INSIGHT_TAG_INFO:
      return {
        ...state,
        tag_id: undefined,
        tag_js_code: undefined,
        tag_info: undefined,
        website_name: undefined,
        website_url: undefined,
        campaign_name: undefined,
      };

    case CLEAR_TAG_ERROR:
      return {
        ...state,
        tag_error_message: undefined,
        tag_updated_success: undefined,
      };
    case success(GET_TAG_DETAIL):
      return {
        ...state,
        tag_info: action.payload,
      };
    case CLEAR_AUDIENCE_FILES_DATA:
      return {
        ...state,
        audience_file_data: undefined,
      };
    /*
		case ADD_TAG_VARIABLE:
			const vars = state.tag_variables
			if (vars.length < 5)
				vars.push("")
			return{
				...state,
				tag_variables: vars
			}*/
    case success(GET_AUDIENCE_FILES_DATA):
      return {
        ...state,
        audience_file_data: action.payload,
      };
    case success(GET_TAG_AUDIENCE_FILES):
      return {
        ...state,
        audience_files: action.payload,
      };
    case request(DOWNLOAD_AUDIENCE_FILES):
      return {
        ...state,
        audience_file_error: undefined,
        audience_file_blob: undefined,
      };
    case success(DOWNLOAD_AUDIENCE_FILES):
      return {
        ...state,
        audience_file_blob: action.payload,
      };
    case invalid(DOWNLOAD_AUDIENCE_FILES):
    case failure(DOWNLOAD_AUDIENCE_FILES):
      return {
        ...state,
        audience_file_error: action.payload
          ? action.payload.message
          : "Error when download audience file, please try again",
      };
    case request(SEND_ASSIST_REQUEST):
      return {
        ...state,
        send_assist_request_error: undefined,
        request_assist_successful: undefined,
      };
    case success(SEND_ASSIST_REQUEST):
      return {
        ...state,
        send_assist_request_error: undefined,
        request_assist_successful: true,
      };
    case invalid(SEND_ASSIST_REQUEST):
    case failure(SEND_ASSIST_REQUEST):
      return {
        ...state,
        send_assist_request_error:
          "Message send failure. Please try again later...",
        request_assist_successful: false,
      };
    case request(OVERVIEW_TRAFFIC_REPORT):
      return {
        ...state,
        loadingOverviewTraffic: true,
        overviewTrafficReport: undefined,
      };
    case success(OVERVIEW_TRAFFIC_REPORT):
      return {
        ...state,
        loadingOverviewTraffic: false,
        overviewTrafficReport: action.payload,
      };
    case invalid(OVERVIEW_TRAFFIC_REPORT):
    case failure(OVERVIEW_TRAFFIC_REPORT):
      return {
        ...state,
        loadingOverviewTraffic: false,
        overviewTrafficReport: undefined,
      };
    case request(DOMESTIC_CONSUMER_VISITS_REPORT):
      return {
        ...state,
        loadingDomesticConsumerVisits: true,
        domesticConsumerVisitsReport: undefined,
      };
    case success(DOMESTIC_CONSUMER_VISITS_REPORT):
      return {
        ...state,
        loadingDomesticConsumerVisits: false,
        domesticConsumerVisitsReport: action.payload,
      };
    case invalid(DOMESTIC_CONSUMER_VISITS_REPORT):
    case failure(DOMESTIC_CONSUMER_VISITS_REPORT):
      return {
        ...state,
        loadingDomesticConsumerVisits: false,
        domesticConsumerVisitsReport: undefined,
      };
    case request(DOMESTIC_BUSINESS_STATS):
      return {
        ...state,
        loadingDomesticBusiness: true,
        domesticBusinessVisitsReport: undefined,
      };
    case success(DOMESTIC_BUSINESS_STATS):
      return {
        ...state,
        loadingDomesticBusiness: false,
        domesticBusinessVisitsReport: action.payload,
      };
    case invalid(DOMESTIC_BUSINESS_STATS):
    case failure(DOMESTIC_BUSINESS_STATS):
      return {
        ...state,
        loadingDomesticBusiness: false,
        domesticBusinessVisitsReport: undefined,
      };
    case CLEAR_ALL_DOMESTIC_STATS:
      return {
        ...state,
        overviewTrafficReport: undefined,
        statsByTime: undefined,
        domesticBusinessVisitsReport: undefined,
        domesticConsumerVisitsReport: undefined,
      };
    case request(GET_DOMESTIC_VISITS):
      return {
        ...state,
        loadingDomesticVisitsSummary: true,
      };
    case success(GET_DOMESTIC_VISITS):
      return {
        ...state,
        domesticVisitsSummary: action.payload,
        loadingDomesticVisitsSummary: false,
      };
    case request(GET_TOP_20_FREQUENCY_BUSINESSES):
      return {
        ...state,
        loadingTop20FrequencyBusinesses: true,
        top20FrequencyBusinesses: undefined,
      };
    case success(GET_TOP_20_FREQUENCY_BUSINESSES):
      return {
        ...state,
        loadingTop20FrequencyBusinesses: false,
        top20FrequencyBusinesses: action.payload,
      };
    case failure(GET_TOP_20_FREQUENCY_BUSINESSES):
    case invalid(GET_TOP_20_FREQUENCY_BUSINESSES):
      return {
        ...state,
        loadingTop20FrequencyBusinesses: false,
        top20FrequencyBusinesses: JSON.parse(top20Buisiness),
      };
    case request(GET_SEGMENT_DISTRIBUTION):
      return {
        ...state,
        loadingSegmentDistribution: true,
        segmentDistributionHouseHold: undefined,
        top5OSBreakDown: undefined,
        detailDistributionReport: undefined,
        deviceModelReport: undefined,
        deviceTypeReport: undefined,
      };
    case success(GET_SEGMENT_DISTRIBUTION):
      return {
        ...state,
        loadingSegmentDistribution: false,
        segmentDistributionHouseHold: action.payload,
      };
    case failure(GET_SEGMENT_DISTRIBUTION):
    case invalid(GET_SEGMENT_DISTRIBUTION):
      return {
        ...state,
        loadingSegmentDistribution: false,
        segmentDistributionHouseHold: undefined,
      };
    case request(GET_TOP_5_OS_BREAKDOWN_REPORT):
      return {
        ...state,
        loadingTop5OSBreakdown: true,
        top5OSBreakDown: undefined,
      };
    case success(GET_TOP_5_OS_BREAKDOWN_REPORT):
      return {
        ...state,
        loadingTop5OSBreakdown: false,
        top5OSBreakDown: action.payload,
      };
    case failure(GET_TOP_5_OS_BREAKDOWN_REPORT):
    case invalid(GET_TOP_5_OS_BREAKDOWN_REPORT):
      return {
        ...state,
        loadingTop5OSBreakdown: false,
        top5OSBreakDown: undefined,
      };
    case request(GET_SEGMENT_DISTRIBUTION_DETAIL_REPORT):
      return {
        ...state,
        loadingDistributionDetailReport: true,
        detailDistributionReport: undefined,
      };
    case success(GET_SEGMENT_DISTRIBUTION_DETAIL_REPORT):
      return {
        ...state,
        loadingDistributionDetailReport: false,
        detailDistributionReport: action.payload,
      };
    case failure(GET_SEGMENT_DISTRIBUTION_DETAIL_REPORT):
    case invalid(GET_SEGMENT_DISTRIBUTION_DETAIL_REPORT):
      return {
        ...state,
        loadingDistributionDetailReport: false,
        detailDistributionReport: undefined,
      };
    case request(GET_SEGMENT_DISTRIBUTION_DEVICE_MODEL_REPORT):
      return {
        ...state,
        loadDeviceModelReport: true,
        deviceModelReport: undefined,
      };
    case success(GET_SEGMENT_DISTRIBUTION_DEVICE_MODEL_REPORT):
      return {
        ...state,
        loadDeviceModelReport: false,
        deviceModelReport: action.payload,
      };
    case failure(GET_SEGMENT_DISTRIBUTION_DEVICE_MODEL_REPORT):
    case invalid(GET_SEGMENT_DISTRIBUTION_DEVICE_MODEL_REPORT):
      return {
        ...state,
        loadDeviceModelReport: false,
        deviceModelReport: undefined,
      };
    case request(GET_SEGMENT_DISTRIBUTION_DEVICE_TYPE_REPORT):
      return {
        ...state,
        loadDeviceTypeReport: true,
        deviceTypeReport: undefined,
      };
    case success(GET_SEGMENT_DISTRIBUTION_DEVICE_TYPE_REPORT):
      return {
        ...state,
        loadDeviceTypeReport: false,
        deviceTypeReport: action.payload,
      };
    case failure(GET_SEGMENT_DISTRIBUTION_DEVICE_TYPE_REPORT):
    case invalid(GET_SEGMENT_DISTRIBUTION_DEVICE_TYPE_REPORT):
      return {
        ...state,
        loadDeviceTypeReport: false,
        deviceTypeReport: undefined,
      };
    case request(GET_INSIGHTS_POPULAR_PAGES):
      return {
        ...state,
        loadingPopularPages: true,
        mostPopularPages: undefined,
        loadingPopularPagesError: undefined,
        setFavoriteError: undefined,
      };
    case success(GET_INSIGHTS_POPULAR_PAGES):
      return {
        ...state,
        loadingPopularPages: false,
        mostPopularPages: action.payload,
        loadingPopularPagesError: undefined,
      };
    case invalid(GET_INSIGHTS_POPULAR_PAGES):
    case failure(GET_INSIGHTS_POPULAR_PAGES):
      return {
        ...state,
        loadingPopularPages: false,
        mostPopularPages: undefined,
        loadingPopularPagesError: action.payload.message,
      };
    case request(SET_PAGE_FAVORITE):
      return {
        ...state,
        favoriting: true,
        setFavoriteError: undefined,
      };
    case success(SET_PAGE_FAVORITE):
      return {
        ...state,
        favoriting: false,
        setFavoriteError: undefined,
      };
    case invalid(SET_PAGE_FAVORITE):
    case failure(SET_PAGE_FAVORITE):
      return {
        ...state,
        favoriting: false,
        setFavoriteError: action.payload.message,
      };
    case request(GET_FAVORITE_PAGES):
      return {
        ...state,
        loadingFavoritePages: true,
        favoritePages: undefined,
        loadingFavoritePagesError: undefined,
      };
    case success(GET_FAVORITE_PAGES):
      return {
        ...state,
        loadingFavoritePages: false,
        favoritePages: action.payload,
        loadingFavoritePagesError: undefined,
      };
    case invalid(GET_FAVORITE_PAGES):
    case failure(GET_FAVORITE_PAGES):
      return {
        ...state,
        loadingFavoritePages: false,
        favoritePages: undefined,
        loadingFavoritePagesError: action.payload.message,
      };
    case CLEAR_CREATE_SCALE_AUDIENCE_INFO:
      return {
        ...state,
        savingScaleAudience: undefined,
        savingScaleAudienceResult: undefined,
        savingScaleAudienceError: undefined,
      };
    case CLEAR_CREATE_VISITORS_AUDIENCE_INFO:
      return {
        ...state,
        savingVisitorsAudience: undefined,
        savingVisitorsAudienceResult: undefined,
        savingVisitorsAudienceError: undefined,
      };
    case request(CREATE_AUDIENCE_AT_SCALE):
      return {
        ...state,
        savingScaleAudience: true,
        savingScaleAudienceResult: undefined,
        savingScaleAudienceError: undefined,
      };
    case success(CREATE_AUDIENCE_AT_SCALE):
      return {
        ...state,
        savingScaleAudience: false,
        savingScaleAudienceResult: action.payload,
        savingScaleAudienceError: undefined,
      };
    case invalid(CREATE_AUDIENCE_AT_SCALE):
    case failure(CREATE_AUDIENCE_AT_SCALE):
      return {
        ...state,
        savingScaleAudience: false,
        savingScaleAudienceResult: undefined,
        savingScaleAudienceError: action.payload,
      };
    case request(CREATE_AUDIENCE_AT_VISITORS):
      return {
        ...state,
        savingVisitorsAudience: true,
        savingVisitorsAudienceResult: undefined,
        savingVisitorsAudienceError: undefined,
      };
    case success(CREATE_AUDIENCE_AT_VISITORS):
      return {
        ...state,
        savingVisitorsAudience: undefined,
        savingVisitorsAudienceResult: action.payload,
        savingVisitorsAudienceError: undefined,
      };
    case invalid(CREATE_AUDIENCE_AT_VISITORS):
    case failure(CREATE_AUDIENCE_AT_VISITORS):
      return {
        ...state,
        savingVisitorsAudience: false,
        savingVisitorsAudienceResult: undefined,
        savingVisitorsAudienceError: action.payload,
      };
    case success(GET_BY_STATES):
      return {
        ...state,
        states: action.payload,
      };
    case request(GET_SEGMENT_DISTRIBUTION_SYSTEMS):
      return {
        ...state,
        segmentDistributionSystems: undefined,
      };
    case success(GET_SEGMENT_DISTRIBUTION_SYSTEMS):
      return {
        ...state,
        segmentDistributionSystems: action.payload,
      };
    case request(GET_CULTURE_CODE_REPORT):
      return {
        ...state,
        cultureCodeReport: undefined,
      };
    case success(GET_CULTURE_CODE_REPORT):
      return {
        ...state,
        cultureCodeReport: action.payload,
      };
    case request(GET_HEATMAP_DATA):
      return {
        ...state,
        distributionHeatmapLoading: true,
        distributionHeatmapData: undefined,
      };
    case success(GET_HEATMAP_DATA):
      return {
        ...state,
        distributionHeatmapLoading: undefined,
        distributionHeatmapData: action.payload,
      };
    default:
      return state;
  }
};

export default {
  insights,
};



// WEBPACK FOOTER //
// ./src/reducers/insights.js